import type { OrderLineItem } from "@babackapp/return-widget-components/types";

export function formatVariantOptions(lineItem: OrderLineItem): string {
  return [lineItem.variant?.option1, lineItem.variant?.option2, lineItem.variant?.option3]
    .filter(Boolean)
    .filter((o) => o !== "Default Title")
    .join(" • ");
}
